!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t.ReactIntlLocaleData = t.ReactIntlLocaleData || {}, t.ReactIntlLocaleData.se = e());
}(this, function () {
  "use strict";

  return [{
    locale: "se",
    pluralRuleFunction: function pluralRuleFunction(t, e) {
      return e ? "other" : 1 == t ? "one" : 2 == t ? "two" : "other";
    },
    fields: {
      year: {
        displayName: "jáhki",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            one: "{0} jahki maŋŋilit",
            two: "{0} jahkki maŋŋilit",
            other: "{0} jahkki maŋŋilit"
          },
          past: {
            one: "{0} jahki árat",
            two: "{0} jahkki árat",
            other: "{0} jahkki árat"
          }
        }
      },
      "year-short": {
        displayName: "jáhki",
        relative: {
          0: "this year",
          1: "next year",
          "-1": "last year"
        },
        relativeTime: {
          future: {
            one: "{0} jahki maŋŋilit",
            two: "{0} jahkki maŋŋilit",
            other: "{0} jahkki maŋŋilit"
          },
          past: {
            one: "{0} jahki árat",
            two: "{0} jahkki árat",
            other: "{0} jahkki árat"
          }
        }
      },
      month: {
        displayName: "mánnu",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            one: "{0} mánotbadji maŋŋilit",
            two: "{0} mánotbadji maŋŋilit",
            other: "{0} mánotbadji maŋŋilit"
          },
          past: {
            one: "{0} mánotbadji árat",
            two: "{0} mánotbadji árat",
            other: "{0} mánotbadji árat"
          }
        }
      },
      "month-short": {
        displayName: "mánnu",
        relative: {
          0: "this month",
          1: "next month",
          "-1": "last month"
        },
        relativeTime: {
          future: {
            one: "{0} mánotbadji maŋŋilit",
            two: "{0} mánotbadji maŋŋilit",
            other: "{0} mánotbadji maŋŋilit"
          },
          past: {
            one: "{0} mánotbadji árat",
            two: "{0} mánotbadji árat",
            other: "{0} mánotbadji árat"
          }
        }
      },
      day: {
        displayName: "beaivi",
        relative: {
          0: "odne",
          1: "ihttin",
          2: "paijeelittáá",
          "-2": "oovdebpeivvi",
          "-1": "ikte"
        },
        relativeTime: {
          future: {
            one: "{0} jándor maŋŋilit",
            two: "{0} jándor amaŋŋilit",
            other: "{0} jándora maŋŋilit"
          },
          past: {
            one: "{0} jándor árat",
            two: "{0} jándora árat",
            other: "{0} jándora árat"
          }
        }
      },
      "day-short": {
        displayName: "beaivi",
        relative: {
          0: "odne",
          1: "ihttin",
          2: "paijeelittáá",
          "-2": "oovdebpeivvi",
          "-1": "ikte"
        },
        relativeTime: {
          future: {
            one: "{0} jándor maŋŋilit",
            two: "{0} jándor amaŋŋilit",
            other: "{0} jándora maŋŋilit"
          },
          past: {
            one: "{0} jándor árat",
            two: "{0} jándora árat",
            other: "{0} jándora árat"
          }
        }
      },
      hour: {
        displayName: "diibmu",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "{0} diibmu maŋŋilit",
            two: "{0} diibmur maŋŋilit",
            other: "{0} diibmur maŋŋilit"
          },
          past: {
            one: "{0} diibmu árat",
            two: "{0} diibmur árat",
            other: "{0} diibmur árat"
          }
        }
      },
      "hour-short": {
        displayName: "diibmu",
        relative: {
          0: "this hour"
        },
        relativeTime: {
          future: {
            one: "{0} diibmu maŋŋilit",
            two: "{0} diibmur maŋŋilit",
            other: "{0} diibmur maŋŋilit"
          },
          past: {
            one: "{0} diibmu árat",
            two: "{0} diibmur árat",
            other: "{0} diibmur árat"
          }
        }
      },
      minute: {
        displayName: "minuhtta",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "{0} minuhta maŋŋilit",
            two: "{0} minuhtta maŋŋilit",
            other: "{0} minuhtta maŋŋilit"
          },
          past: {
            one: "{0} minuhta árat",
            two: "{0} minuhtta árat",
            other: "{0} minuhtta árat"
          }
        }
      },
      "minute-short": {
        displayName: "minuhtta",
        relative: {
          0: "this minute"
        },
        relativeTime: {
          future: {
            one: "{0} minuhta maŋŋilit",
            two: "{0} minuhtta maŋŋilit",
            other: "{0} minuhtta maŋŋilit"
          },
          past: {
            one: "{0} minuhta árat",
            two: "{0} minuhtta árat",
            other: "{0} minuhtta árat"
          }
        }
      },
      second: {
        displayName: "sekunda",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "{0} sekunda maŋŋilit",
            two: "{0} sekundda maŋŋilit",
            other: "{0} sekundda maŋŋilit"
          },
          past: {
            one: "{0} sekunda árat",
            two: "{0} sekundda árat",
            other: "{0} sekundda árat"
          }
        }
      },
      "second-short": {
        displayName: "sekunda",
        relative: {
          0: "now"
        },
        relativeTime: {
          future: {
            one: "{0} sekunda maŋŋilit",
            two: "{0} sekundda maŋŋilit",
            other: "{0} sekundda maŋŋilit"
          },
          past: {
            one: "{0} sekunda árat",
            two: "{0} sekundda árat",
            other: "{0} sekundda árat"
          }
        }
      }
    }
  }, {
    locale: "se-FI",
    parentLocale: "se",
    fields: {
      year: {
        displayName: "jahki",
        relative: {
          0: "dán jagi",
          1: "boahtte jagi",
          "-1": "diibmá"
        },
        relativeTime: {
          future: {
            one: "{0} jagi siste",
            two: "{0} jagi siste",
            other: "{0} jagi siste"
          },
          past: {
            one: "diibmá",
            two: "ovddet jagi",
            other: "{0} jagi dás ovdal"
          }
        }
      },
      "year-short": {
        displayName: "j.",
        relative: {
          0: "dán jagi",
          1: "boahtte jagi",
          "-1": "diibmá"
        },
        relativeTime: {
          future: {
            one: "{0} j. siste",
            two: "{0} jagi siste",
            other: "{0} j. siste"
          },
          past: {
            one: "diibmá",
            two: "ovddet jagi",
            other: "{0} j. dás ovdal"
          }
        }
      },
      month: {
        displayName: "mánnu",
        relative: {
          0: "dán mánu",
          1: "boahtte mánu",
          "-1": "mannan mánu"
        },
        relativeTime: {
          future: {
            one: "{0} mánu siste",
            two: "{0} mánu siste",
            other: "{0} mánu siste"
          },
          past: {
            one: "{0} mánnu dás ovdal",
            two: "{0} mánu dás ovdal",
            other: "{0} mánu dás ovdal"
          }
        }
      },
      "month-short": {
        displayName: "m.",
        relative: {
          0: "dán mánu",
          1: "boahtte mánu",
          "-1": "mannan mánu"
        },
        relativeTime: {
          future: {
            one: "{0} mánu siste",
            two: "{0} mánu siste",
            other: "{0} mánu siste"
          },
          past: {
            one: "{0} mánnu dás ovdal",
            two: "{0} mánu dás ovdal",
            other: "{0} mánu dás ovdal"
          }
        }
      },
      day: {
        displayName: "beaivi",
        relative: {
          0: "odne",
          1: "ihttin",
          2: "don beaivve",
          "-2": "ovddet beaivvi",
          "-1": "ikte"
        },
        relativeTime: {
          future: {
            one: "{0} beaivve siste",
            two: "{0} beaivve siste",
            other: "{0} beaivve siste"
          },
          past: {
            one: "ikte",
            two: "ovddet beaivve",
            other: "{0} beaivve dás ovdal"
          }
        }
      },
      "day-short": {
        displayName: "b.",
        relative: {
          0: "odne",
          1: "ihttin",
          2: "don beaivve",
          "-2": "ovddet beaivvi",
          "-1": "ikte"
        },
        relativeTime: {
          future: {
            one: "{0} beaivve siste",
            two: "{0} beaivve siste",
            other: "{0} beaivve siste"
          },
          past: {
            one: "ikte",
            two: "ovddet beaivve",
            other: "{0} beaivve dás ovdal"
          }
        }
      },
      hour: {
        displayName: "diibmu",
        relative: {
          0: "dán diimmu"
        },
        relativeTime: {
          future: {
            one: "{0} diimmu siste",
            two: "{0} diimmu siste",
            other: "{0} diimmu siste"
          },
          past: {
            one: "{0} diibmu áigi",
            two: "{0} diimmu áigi",
            other: "{0} diimmu áigi"
          }
        }
      },
      "hour-short": {
        displayName: "dmu",
        relative: {
          0: "dán diimmu"
        },
        relativeTime: {
          future: {
            one: "{0} dmu siste",
            two: "{0} diimmu siste",
            other: "{0} dmu siste"
          },
          past: {
            one: "{0} dmu áigi",
            two: "{0} diimmu áigi",
            other: "{0} dmu áigi"
          }
        }
      },
      minute: {
        displayName: "minuhtta",
        relative: {
          0: "dán minuhta"
        },
        relativeTime: {
          future: {
            one: "{0} minuhta siste",
            two: "{0} minuhta siste",
            other: "{0} minuhta siste"
          },
          past: {
            one: "{0} minuhtta áigi",
            two: "{0} minuhta áigi",
            other: "{0} minuhta áigi"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "dán minuhta"
        },
        relativeTime: {
          future: {
            one: "{0} min. siste",
            two: "{0} minuhta siste",
            other: "{0} min. siste"
          },
          past: {
            one: "{0} min. áigi",
            two: "{0} minuhta áigi",
            other: "{0} min. áigi"
          }
        }
      },
      second: {
        displayName: "sekunda",
        relative: {
          0: "dál"
        },
        relativeTime: {
          future: {
            one: "{0} sekundda siste",
            two: "{0} sekundda siste",
            other: "{0} sekundda siste"
          },
          past: {
            one: "{0} sekunda áigi",
            two: "{0} sekundda áigi",
            other: "{0} sekundda áigi"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "dál"
        },
        relativeTime: {
          future: {
            one: "{0} sek. siste",
            two: "{0} sekundda siste",
            other: "{0} sek. siste"
          },
          past: {
            one: "{0} sek. áigi",
            two: "{0} sekundda áigi",
            other: "{0} sek. áigi"
          }
        }
      }
    }
  }, {
    locale: "se-SE",
    parentLocale: "se"
  }];
});